<template>
    <div id="menu">
        <ul>
            <li v-for="(planet, idx) in planetsList" :key="planet">
                <dropdown-menu-item :planet="planet"></dropdown-menu-item>
                <hr v-if="idx !== planetsList.length-1">
            </li>
            
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropdownMenuItem from './DropdownMenuItem.vue';

export default {
    components: {
        DropdownMenuItem
    },
    computed: {
        ...mapGetters(['planetsList'])
    }    
}
</script>

<style scoped>
#menu {
    background-color: #070724;
    position: absolute;
    top: 6rem;
    left: 0;
    z-index: 1;
    height: 92%;
    width: 100%;    
}

hr {
    border-bottom: none;
    border-top: 1px solid #979797;
}

ul {
    list-style: none;
    padding: 0 5%;
}
</style>